import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'
import {
  CONTACT_FILTERS,
  EMAIL_TEMPLATE_FILTERS,
  FINANCE_DEALER_FILTERS,
  MERCHANT_FILTERS,
  SHIPPERS_FILTERS,
  TRUCK_SALES_DEALER_FILTERS,
} from '../../../constants/contactFilterCategory'
import { BRANCH_MANAGER, IS_EXECUTIVE, MANAGER, VIEW_ALL_DIVISION_ACCOUNTS } from '../../../constants/permissions'
import { EXECUTIVE } from '../../../constants/divisions'
import CustomSelect from '../../CustomReactSelectComponent'
import CustomSwitch from '../../CustomSwitchForFilters'
import InputGroup from '../../InputGroup'
import {
  AvailableFiltersContact,
  AvailableFiltersCustomerLogistics,
  AvailableFiltersEmailTemplateContacts,
  AvailableFiltersFinanceDealers,
  AvailableFiltersMerchants,
  AvailableFiltersTSDealers,
} from './AvailableFilters'

const SelectingFiltersSwitches = ({
  contactFilterTypes,
  selectedFilters,
  selectedType,
  isAddingNew,
  newPresetName,
  handlePresetChange,
  handleChange,
  saveNewPreset,
  handleSwitchChange,
  toggleAddNewPreset,
  sendFilters,
  filterCategory,
  deletePreset,
}) => {
  const { isExecutive, isExecutiveDivision, hasManagerPermission, hasViewAllDivisionAccountsPermission } = useSelector(
    (state) => ({
      isExecutiveDivision: state.auth.user.division_id === EXECUTIVE,
      isExecutive: state.auth.user.permissions.includes(IS_EXECUTIVE),
      hasManagerPermission: [MANAGER, BRANCH_MANAGER].some((el) => state.auth.user.permissions.includes(el)),
      hasViewAllDivisionAccountsPermission: state.auth.user.permissions.includes(VIEW_ALL_DIVISION_ACCOUNTS),
    })
  )

  const [allContactsOnly, setAllContactsOnly] = useState(false)

  const location = useLocation()

  useEffect(() => {
    const allContactsOnly = !!(
      location?.pathname.includes('/all-customers') || location?.pathname.includes('/contacts')
    )
    setAllContactsOnly(allContactsOnly)
  }, [location])

  const filtersByColumn = AvailableFiltersContact.reduce((acc, filter) => {
    const col = filter.column ?? 1
    if (!acc[col]) acc[col] = []
    acc[col].push(filter)
    return acc
  }, {})

  return (
    <>
      <Row className='mb-3'>
        {
          <Col xs={3}>
            <CustomSelect
              isMulti={false}
              defaultValue={selectedType}
              options={contactFilterTypes}
              label='Preset Filters'
              onChange={handlePresetChange}
              isClearable={true}
            />
          </Col>
        }
        {isAddingNew && (
          <Col xs={3}>
            <InputGroup label='Preset Name' value={newPresetName} name='newPresetName' onChange={handleChange} />
          </Col>
        )}
        {!isAddingNew && (
          <>
            <Col xs={3}>
              <Button className='mt-4 btn btn-gold btn-sm' onClick={toggleAddNewPreset}>
                Add new preset
              </Button>
            </Col>
            <Col xs={3} />
          </>
        )}
        {isAddingNew && (
          <Col xs={3}>
            <Button className='mt-4 btn btn-gold btn-sm' onClick={saveNewPreset}>
              Save Preset
            </Button>
          </Col>
        )}
        <Col xs={3} className='d-flex justify-content-end'>
          <Button className='mt-4 btn btn-sm' color='danger' onClick={deletePreset} disabled={!selectedType}>
            Delete Preset
          </Button>
        </Col>
      </Row>
      <hr />
      <Row>
        {filterCategory === CONTACT_FILTERS && (
          <>
            {Object.entries(filtersByColumn).map(([columnNumber, filters]) => (
              <Col key={columnNumber} xs={12} sm={6} md={3}>
                {filters.map((filter) => {
                  if (!isExecutiveDivision && filter.name === 'division_leads') return <></>
                  if (!allContactsOnly && filter.name === 'account_date') return <></>
                  if (!isExecutive && filter.name === 'is_ex_yu') return <></>
                  if (!hasManagerPermission && filter.name === 'salesperson') return <></>
                  if (!hasViewAllDivisionAccountsPermission && filter.name === 'division_accounts') return <></>
                  if ((!isExecutiveDivision || (isExecutive && allContactsOnly)) && filter.name === 'division_id')
                    return <></>

                  return (
                    <Row key={filter.id}>
                      <Col>
                        <CustomSwitch
                          labelName={filter.label}
                          checked={selectedFilters[filter.name]}
                          name={filter.name}
                          id={filter.id}
                          onChange={(e) => handleSwitchChange(e, filter.extension)}
                        />
                      </Col>
                    </Row>
                  )
                })}
              </Col>
            ))}
          </>
        )}
        {filterCategory === MERCHANT_FILTERS &&
          AvailableFiltersMerchants.map((filter) => {
            return (
              <Col xs={3} key={filter.id}>
                <CustomSwitch
                  labelName={filter.label}
                  checked={selectedFilters[filter.name]}
                  name={filter.name}
                  onChange={handleSwitchChange}
                />
              </Col>
            )
          })}
        {filterCategory === SHIPPERS_FILTERS &&
          AvailableFiltersCustomerLogistics.map((filter) => {
            if (!allContactsOnly && filter.name === 'account_date') {
              return <></>
            }

            return (
              <Col xs={3} key={filter.id}>
                <CustomSwitch
                  labelName={filter.label}
                  checked={selectedFilters[filter.name]}
                  name={filter.name}
                  onChange={handleSwitchChange}
                />
              </Col>
            )
          })}
        {filterCategory === TRUCK_SALES_DEALER_FILTERS &&
          AvailableFiltersTSDealers.map((filter) => {
            return (
              <Col xs={3} key={filter.id}>
                <CustomSwitch
                  labelName={filter.label}
                  checked={selectedFilters[filter.name]}
                  name={filter.name}
                  onChange={handleSwitchChange}
                />
              </Col>
            )
          })}
        {filterCategory === FINANCE_DEALER_FILTERS &&
          AvailableFiltersFinanceDealers.map((filter) => {
            return (
              <Col xs={3} key={filter.id}>
                <CustomSwitch
                  labelName={filter.label}
                  checked={selectedFilters[filter.name]}
                  name={filter.name}
                  onChange={handleSwitchChange}
                />
              </Col>
            )
          })}
        {filterCategory === EMAIL_TEMPLATE_FILTERS &&
          AvailableFiltersEmailTemplateContacts.map((filter) => {
            if (filter.name === 'is_ex_yu') {
              return (
                <Col xs={3} key={filter.id}>
                  <CustomSwitch
                    disabled={!isExecutive}
                    labelName={filter.label}
                    checked={selectedFilters[filter.name]}
                    name={filter.name}
                    onChange={handleSwitchChange}
                  />
                </Col>
              )
            }

            return (
              <Col xs={3} key={filter.id}>
                <CustomSwitch
                  labelName={filter.label}
                  checked={selectedFilters[filter.name]}
                  name={filter.name}
                  onChange={handleSwitchChange}
                />
              </Col>
            )
          })}
      </Row>
      <Row className='flex-row-reverse mr-3' style={{ paddingTop: '10px' }}>
        <Button className='btn btn-gold btn-sm' onClick={sendFilters}>
          Save selected filters
        </Button>
      </Row>
    </>
  )
}

SelectingFiltersSwitches.propTypes = {
  contactFilterTypes: PropTypes.array.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  selectedType: PropTypes.number.isRequired,
  isAddingNew: PropTypes.bool.isRequired,
  newPresetName: PropTypes.string.isRequired,

  sendFilters: PropTypes.func.isRequired,
  handlePresetChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  saveNewPreset: PropTypes.func.isRequired,
  handleSwitchChange: PropTypes.func.isRequired,
  toggleAddNewPreset: PropTypes.func.isRequired,
}

export default SelectingFiltersSwitches
